import React, { Fragment, useEffect, useState } from "react";
import { Paper, Typography} from "@material-ui/core";
import { useStyles } from "./classes";
import * as api from "../../api/index.js";

const FavoriteRestaurant = () => {
  const classes = useStyles();

   const [data,   setData] = useState([]);;;

 useEffect(() => {
   (async () => {
     const { data } = await api.userFav();
     setData(data);
   })();
 }, []);

  return (
    <Fragment>
      <Typography className={classes.menuInfo}>Favorite Restaurants</Typography>

      <Paper className={classes.menus}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignContent: "flex-start",
            alignItems: "space-between",
          }}
        >
          {data.map((res) => (
            <Paper className={classes.list} key={res.name}>
              <img
                src={res.logo}
                style={{
                  width: "90%",
                  height: "90%",
                  marginLeft: "5%",
                  marginRight: "5%",
                  marginTop: "8px",
                }}
                alt="restaurant"
              ></img>

                <Typography className={classes.editInfo}>{res.name}</Typography>    
                <br/>           
            </Paper>
          ))}
        </div>
      </Paper>
    </Fragment>
  );
};

export default FavoriteRestaurant;
